import { Fade } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import CardCheckList from "../../../../components/ui/cards/card-check-list/card-check-list";
import "./consultancy-offer.scss";

const ConsultancyOffer = () => {
  return (
    <section className="consultancy-offer">
      <Fade direction="up" duration={600} triggerOnce>
        <IntroSectionBadge
          badgeText={"TIPOLOGIE DI SERVIZIO"}
          title={"Cosa Offriamo"}
          bgColor={"light"}
          icon="cube"
        />
      </Fade>
      <div className="consultancy-offer__cards-list">
        <Fade direction="up" duration={900} cascade damping={0.2} triggerOnce>
          <CardCheckList
            title="Analisi del Terreno"
            text="Ti indirizziamo a laboratori e studi specializzati per eseguire le prove e le analisi necessarie."
            icon="microscope"
            type="secondary"
            elements={[
              "Prove penetrometriche e in sito",
              "Sondaggi geognostici",
              "Relazioni tecniche",
            ]}
          />
          <CardCheckList
            title="Progettazione"
            text="I professionisti incaricati sviluppano il progetto tecnico. Noi seguiamo il processo per garantire coerenza con la fase di cantiere."
            icon="compass"
            type="primary"
            elements={[
              "Dettagli costruttivi e dimensionamento",
              "Calcoli e schede tecniche",
              "Ottimizzazione in fase di esecuzione",
            ]}
          />
          <CardCheckList
            title="Esecuzione e Coordinamento"
            text="Realizziamo le opere in base al progetto approvato, mantenendo un costante confronto tecnico con i progettisti e gli specialisti coinvolti."
            icon="helmet"
            type="secondary"
            elements={[
              "Controllo qualità in fase operativa",
              "Coordinamento tecnico con i professionisti",
              "Collaudi finali (inclusa relazione prove di carico)",
            ]}
          />
        </Fade>
      </div>
    </section>
  );
};

export default ConsultancyOffer;
